var map = {
	"./": 35,
	"./App": 60,
	"./App.js": 60,
	"./assets/images/amenities/banner.jpg": 165,
	"./assets/images/amenities/lounge.jpg": 166,
	"./assets/images/amenities/sitemap.jpg": 167,
	"./assets/images/developer/banner.jpg": 168,
	"./assets/images/developer/gallery/bining-tower.jpg": 169,
	"./assets/images/developer/gallery/capitol.jpg": 170,
	"./assets/images/developer/gallery/hudson.jpg": 171,
	"./assets/images/developer/gallery/one-wall.jpg": 172,
	"./assets/images/developer/gallery/shannon-wall-2.jpg": 173,
	"./assets/images/developer/gallery/shannon-wall.jpg": 174,
	"./assets/images/developer/gallery/wall-centre-2.jpg": 175,
	"./assets/images/developer/gallery/wall-centre-3.jpg": 176,
	"./assets/images/developer/gallery/wall-centre-4.jpg": 177,
	"./assets/images/developer/gallery/wall-centre.jpg": 178,
	"./assets/images/developer/wallfinancial-logo.svg": 179,
	"./assets/images/floorplans/banner.jpg": 180,
	"./assets/images/footer/rennie.svg": 181,
	"./assets/images/footer/wallfinancial.svg": 182,
	"./assets/images/home/amenities.jpg": 183,
	"./assets/images/home/bg.jpg": 51,
	"./assets/images/home/developer.jpg": 184,
	"./assets/images/home/floorplans.jpg": 185,
	"./assets/images/home/interiors.jpg": 186,
	"./assets/images/home/neighbourhood.jpg": 187,
	"./assets/images/icons/close.svg": 188,
	"./assets/images/icons/info.svg": 189,
	"./assets/images/icons/ivy.svg": 190,
	"./assets/images/icons/next.svg": 191,
	"./assets/images/icons/play.svg": 192,
	"./assets/images/icons/scroll.svg": 193,
	"./assets/images/interiors/banner.jpg": 194,
	"./assets/images/interiors/banner2.jpg": 195,
	"./assets/images/interiors/banner3.jpg": 196,
	"./assets/images/interiors/ensuite.jpg": 197,
	"./assets/images/interiors/pattern.png": 419,
	"./assets/images/interiors/triangle.png": 198,
	"./assets/images/logo.svg": 47,
	"./assets/images/neighbourhood/banner.jpg": 199,
	"./assets/images/neighbourhood/collage.jpg": 88,
	"./assets/images/neighbourhood/gallery-1/ubc1.jpg": 200,
	"./assets/images/neighbourhood/gallery-1/ubc2.jpg": 201,
	"./assets/images/neighbourhood/gallery-1/ubc3.jpg": 202,
	"./assets/images/neighbourhood/gallery-1/vegetables.jpg": 203,
	"./assets/images/neighbourhood/gallery-2/img1.jpg": 204,
	"./assets/images/neighbourhood/gallery-2/img2.jpg": 205,
	"./assets/images/neighbourhood/gallery-2/img3.jpg": 206,
	"./assets/images/neighbourhood/gallery-2/img4.jpg": 207,
	"./assets/images/register/bg.jpg": 420,
	"./assets/images/thankyou/bg.jpg": 421,
	"./components/BannerImage": 14,
	"./components/BannerImage.js": 14,
	"./components/Button": 24,
	"./components/Button.js": 24,
	"./components/ButtonLink": 89,
	"./components/ButtonLink.js": 89,
	"./components/ColumnTwo": 25,
	"./components/ColumnTwo.js": 25,
	"./components/Container": 5,
	"./components/Container.js": 5,
	"./components/ContentBlock": 18,
	"./components/ContentBlock.js": 18,
	"./components/ContentBlockFull": 52,
	"./components/ContentBlockFull.js": 52,
	"./components/Counter": 90,
	"./components/Counter.js": 90,
	"./components/Footer": 91,
	"./components/Footer.js": 91,
	"./components/Header/Header": 77,
	"./components/Header/Header.js": 77,
	"./components/Header/elements/Icon": 79,
	"./components/Header/elements/Icon.js": 79,
	"./components/Header/elements/LanguageSelect": 78,
	"./components/Header/elements/LanguageSelect.js": 78,
	"./components/Header/elements/NavigationMobile": 80,
	"./components/Header/elements/NavigationMobile.js": 80,
	"./components/Logo": 208,
	"./components/Logo.js": 208,
	"./components/Page": 9,
	"./components/Page.js": 9,
	"./components/ScrollAnimation": 15,
	"./components/ScrollAnimation.js": 15,
	"./components/Slider": 53,
	"./components/Slider.js": 53,
	"./components/Spacing": 54,
	"./components/Spacing.js": 54,
	"./config/app.conf": 32,
	"./config/app.conf.js": 32,
	"./config/locales/en": 75,
	"./config/locales/en.js": 75,
	"./config/locales/zh": 76,
	"./config/locales/zh.js": 76,
	"./data/features": 92,
	"./data/features.js": 92,
	"./data/map": 93,
	"./data/map.js": 93,
	"./data/plans": 94,
	"./data/plans.js": 94,
	"./data/sitemap": 95,
	"./data/sitemap.js": 95,
	"./index": 35,
	"./index.js": 35,
	"./pages/About": 209,
	"./pages/About.js": 209,
	"./pages/Amenities/Amenities": 210,
	"./pages/Amenities/Amenities.js": 210,
	"./pages/Amenities/elements/Hotspot": 211,
	"./pages/Amenities/elements/Hotspot.js": 211,
	"./pages/Amenities/elements/Sitemap": 96,
	"./pages/Amenities/elements/Sitemap.js": 96,
	"./pages/Developer/Developer": 212,
	"./pages/Developer/Developer.js": 212,
	"./pages/Home/Home": 213,
	"./pages/Home/Home.js": 213,
	"./pages/Home/elements/Hero": 97,
	"./pages/Home/elements/Hero.js": 97,
	"./pages/Home/elements/ParallaxCard": 98,
	"./pages/Home/elements/ParallaxCard.js": 98,
	"./pages/Home/elements/ParallaxCardFull": 99,
	"./pages/Home/elements/ParallaxCardFull.js": 99,
	"./pages/Interiors/Interiors": 214,
	"./pages/Interiors/Interiors.js": 214,
	"./pages/Interiors/elements/Accordion/Accordion": 100,
	"./pages/Interiors/elements/Accordion/Accordion.js": 100,
	"./pages/Interiors/elements/Accordion/elements/List": 101,
	"./pages/Interiors/elements/Accordion/elements/List.js": 101,
	"./pages/Neighbourhood/Neighbourhood": 215,
	"./pages/Neighbourhood/Neighbourhood.js": 215,
	"./pages/Neighbourhood/elements/Map/Map": 102,
	"./pages/Neighbourhood/elements/Map/Map.js": 102,
	"./pages/Neighbourhood/elements/Map/elements/MainMarker": 105,
	"./pages/Neighbourhood/elements/Map/elements/MainMarker.js": 105,
	"./pages/Neighbourhood/elements/Map/elements/Marker": 106,
	"./pages/Neighbourhood/elements/Map/elements/Marker.js": 106,
	"./pages/Neighbourhood/elements/Map/elements/Tabs": 103,
	"./pages/Neighbourhood/elements/Map/elements/Tabs.js": 103,
	"./pages/Neighbourhood/elements/Map/elements/TabsMobile": 104,
	"./pages/Neighbourhood/elements/Map/elements/TabsMobile.js": 104,
	"./pages/Neighbourhood/elements/Map/styles": 107,
	"./pages/Neighbourhood/elements/Map/styles.js": 107,
	"./pages/NotFound": 222,
	"./pages/NotFound.js": 222,
	"./pages/Plans/Plans": 223,
	"./pages/Plans/Plans.js": 223,
	"./pages/Plans/elements/Info": 110,
	"./pages/Plans/elements/Info.js": 110,
	"./pages/Plans/elements/List": 108,
	"./pages/Plans/elements/List.js": 108,
	"./pages/Plans/elements/Overlay": 109,
	"./pages/Plans/elements/Overlay.js": 109,
	"./pages/Register/Register": 224,
	"./pages/Register/Register.js": 224,
	"./pages/Register/elements/Form/Form": 111,
	"./pages/Register/elements/Form/Form.js": 111,
	"./pages/Register/elements/Form/elements/Checkbox": 114,
	"./pages/Register/elements/Form/elements/Checkbox.js": 114,
	"./pages/Register/elements/Form/elements/Input": 112,
	"./pages/Register/elements/Form/elements/Input.js": 112,
	"./pages/Register/elements/Form/elements/Recaptcha": 226,
	"./pages/Register/elements/Form/elements/Recaptcha.js": 226,
	"./pages/Register/elements/Form/elements/Select": 113,
	"./pages/Register/elements/Form/elements/Select.js": 113,
	"./pages/Thankyou/Thankyou": 227,
	"./pages/Thankyou/Thankyou.js": 227,
	"./plugins/i18n": 73,
	"./plugins/i18n.js": 73,
	"./plugins/language": 70,
	"./plugins/language.js": 70,
	"./plugins/prerender": 69,
	"./plugins/prerender.js": 69,
	"./redux/browser": 40,
	"./redux/browser.js": 40,
	"./redux/counter": 39,
	"./redux/counter.js": 39,
	"./redux/reducers": 59,
	"./redux/reducers.js": 59,
	"./redux/store": 58,
	"./redux/store.js": 58,
	"./routes": 228,
	"./routes.js": 228,
	"./styles/global": 68,
	"./styles/global.js": 68,
	"./styles/media": 3,
	"./styles/media.js": 3,
	"./styles/theme": 41,
	"./styles/theme.js": 41,
	"./utils/translate": 4,
	"./utils/translate.js": 4
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 418;


//////////////////
// WEBPACK FOOTER
// ./src ^\.\/.*$
// module id = 418
// module chunks = 0